import { css } from '@emotion/css';
import React, { ButtonHTMLAttributes } from 'react';
import { ReactComponent as Caret } from 'src/assets/images/home/next-page.svg';

type PageButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { direction: 'left' | 'right' };

export const PageButton: React.FC<PageButtonProps> = ({
  onClick,
  direction,
  children,
  ...rest
}) => {
  return (
    <button
      className={css`
        width: 44px;
        height: 44px;
        margin: 0;
        padding: 0;
        line-height: 0;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49);
        &:active {
          transform: scale(0.85);
        }
      `}
      onClick={onClick}
      {...rest}
    >
      <Caret
        className={css`
          transform: ${direction === 'left' ? 'scale(-1, 1)' : 'scale(1)'};
        `}
      />
      {children}
    </button>
  );
};
